/* istanbul ignore file */
export const dict = {
  you: 'You',
  inCallPanelTitle: 'In call with',
  addToCall: 'Add to call',
  transfer: 'Transfer',
  chat: 'Chat',
  info: 'Info',
  room: 'Room',
  country: 'Country',
  browser: 'Browser',
  microphone: 'Microphone',
  camera: 'Camera',
  on: 'On',
  off: 'Off',
  mobile: 'Mobile',
  tablet: 'Tablet',
  desktop: 'Desktop',
  microphoneTurnOn: 'Turn on microphone',
  microphoneTurnOff: 'Turn off microphone',
  shareScreen: 'Share screen',
  unshareScreen: 'Unshare screen',
  callMenu: 'Call menu',
  pictureInPicture: 'Picture-in-Picture',
  pinPreview: 'Pin preview',
  minimizePreview: 'Collapse preview',
  expandPreview: 'Expand preview',
  callDuration: 'Call duration: ',
  waitingFor: (time: string): string => `Waiting for ${time} min`,
  comingSoon: ', coming soon',
  callTransfer: 'Call transfer',
  unexpectedError: 'Something went wrong',
  leaveCallConfirmation: `Leave call?`,
  errorOccurred: 'An error occurred.',
  clickToGoDashboard: 'Please click here to go back to the dashboard',
  clickToGoCheckin: 'Please click here to go back to check-in',
  participant: 'Participant',
  isTyping: 'is typing',
};
